/* eslint-disable no-use-before-define */
import React from 'react'
import {getState } from '../../twd/twd'

const state = getState('corporates.market-news', {
    tab: 'CUSTOM',

    customSearchType: 'company',
    customKeyword: '',
    customSearch: '',
    customIndustry: [],
    customDate: 'today',

    holdingCompany: [],
    holdingDate: 'today',
})

const useContext = ({modal=false}={}) => {
    const [isModal] = React.useState(modal)

    const [tab, setTab_] = React.useState(state.value.tab || 'CUSTOM')
    const setTab = React.useCallback((a) => { state.set({tab:a}); setTab_(a) }, [])

    // custom-tab
    const [customSearchType, setCustomSearchType_] = React.useState(state.value.customSearchType || 'company')
    const setCustomSearchType = React.useCallback((a) => { state.set({customSearchType:a}); setCustomSearchType_(a) }, [])

    const [customKeyword, setCustomKeyword_] = React.useState(state.value.customSearch || '')
    const setCustomKeyword= React.useCallback((a) => { state.set({customKeyword:a}); setCustomKeyword_(a) }, [])

    const [customSearch, setCustomSearch_] = React.useState(state.value.customSearch || '')
    const setCustomSearch = React.useCallback((a) => { state.set({customSearch:a}); setCustomSearch_(a) }, [])

    const [customIndustry, setCustomIndustry_] = React.useState(state.value.customIndustry || [])
    const setCustomIndustry = React.useCallback((a) => { state.set({customIndustry:a}); setCustomIndustry_(a) }, [])

    const [customDate, setCustomDate_] = React.useState(state.value.customDate || 'today')
    const setCustomDate = React.useCallback((a) => { state.set({customDate:a}); setCustomDate_(a) }, [])

    // holding-tab
    const [holdingCompany, setHoldingCompany_] = React.useState(state.value.holdingCompany || [])
    const setHoldingCompany = React.useCallback((a) => { state.set({holdingCompany:a}); setHoldingCompany_(a) }, [])

    const [holdingDate, setHoldingDate_] = React.useState(state.value.holdingDate || 'today')
    const setHoldingDate = React.useCallback((a) => { state.set({holdingDate:a}); setHoldingDate_(a) }, [])

    return {
        isModal,
        tab, setTab,

        customSearchType, setCustomSearchType,
        customKeyword, setCustomKeyword,
        customSearch, setCustomSearch,
        customIndustry, setCustomIndustry,
        customDate, setCustomDate,

        holdingCompany, setHoldingCompany,
        holdingDate, setHoldingDate,
    }
}

export const Context = React.createContext()
export const ContextProvider = ({modal, children}) => {
    const ctx = useContext({modal})
    return <Context.Provider value={ctx}>{children}</Context.Provider>
}
export default () => React.useContext(Context)
